import { useAppDispatch, useAppSelector } from "@app/hooks"
import { CourseClassRegistrationClient } from "@clients/courseClassRegistrationClient"
import { unregisterStudentFromCourseUpdated } from "@features/program/programSlice"
import { Typography } from "@mui/material"
import CourseClassRegistrationPopup from "./courseClassRegistrationPopup"

function UnregisterStudentFromCourseClassPopup() {
  const model = useAppSelector(
    (state) => state.program.studentsPage.unregisterStudentFromCourseClassPopup,
  )
  const dispatch = useAppDispatch()

  const onClose = () => dispatch(unregisterStudentFromCourseUpdated(undefined))

  return (
    <CourseClassRegistrationPopup
      model={model}
      title={
        model ? (
          <Typography variant="h6">
            <Typography component="span" variant="inherit" color="error.main">
              Unregister
            </Typography>{" "}
            {model.firstName} {model.lastName} from a course
          </Typography>
        ) : (
          ""
        )
      }
      confirmText="Unregister"
      onClose={onClose}
      onConfirm={({ courseClassId, studentId, userClientId }) =>
        CourseClassRegistrationClient.dummyUnregisterStudentFromClass(
          courseClassId,
          studentId,
          new Date(),
          userClientId,
        )
      }
    />
  )
}

export default UnregisterStudentFromCourseClassPopup
